import { defineLocaleTargets } from './utilities';

export const ErrorLocales = defineLocaleTargets('error', <const>{
	loadingProducts: '',
	noProductsFound: '',
	unknown: '',
});
